import { combineReducers } from 'redux';

import { app } from '../modules/app/reducer';
import { applicableRestrictionsReducer } from '../modules/applicableRestrictions';
import { availableCategoriesReducer } from '../modules/availableCategories';
import { configurationReducer } from '../modules/configuration/reducer';
import { ageCategoriesReducer } from '../modules/entities/ageCategories/reducer';
import { availabilityBlocksReducer } from '../modules/entities/availabilityBlocks/reducer';
import { bookingEnginesSlice } from '../modules/entities/bookingEngines/reducers';
import { categoryImageAssignmentsReducer } from '../modules/entities/categoryImageAssignments/reducer';
import { chainsReducer } from '../modules/entities/chains/reducer';
import { citiesReducer } from '../modules/entities/cities/reducer';
import { enterprisesReducer } from '../modules/entities/enterprises/reducer';
import { exchangeRates } from '../modules/entities/exchangeRates/reducer';
import { paymentCardAuthorizations } from '../modules/entities/paymentCardAuthorizations/reducer';
import { paymentCards } from '../modules/entities/paymentCards/reducer';
import { paymentRequests } from '../modules/entities/paymentRequests/reducer';
import { payments } from '../modules/entities/payments/reducer';
import { productPricingReducer } from '../modules/entities/productPricing/reducer';
import { rateGroupsReducer } from '../modules/entities/rateGroups/reducer';
import { ratesReducer } from '../modules/entities/rates/reducer';
import { reservationPricesReducer } from '../modules/entities/reservationPrices/reducer';
import { reservations } from '../modules/entities/reservations/reducer';
import { restrictionsSlice } from '../modules/entities/restrictions/reducer';
import { serviceDocumentsSlice } from '../modules/entities/serviceDocuments/reducer';
import { servicesReducer } from '../modules/entities/services/reducer';
import { globalization } from '../modules/globalization/reducer';
import { hotelsReducer } from '../modules/hotels/reducer';
import { paymentConfigurations } from '../modules/paymentConfigurations/reducer';
import { pricingReducer } from '../modules/pricing/reducer';
import { productsReducer } from '../modules/products/reducer';
import { promotedServiceCategoriesReducer } from '../modules/promotedServiceCategories';
import { promotedServicesReducer } from '../modules/promotedServices';
import { reservationGroupsReducer } from '../modules/reservationGroups/reducer';
import { resourceCategoriesReducer } from '../modules/resourceCategories/reducer';
import { resourceOrder } from '../modules/resourceOrder/reducer';
import { sellLimitsReducer } from '../modules/sellLimits/reducer';
import { serviceAvailabilityReducer } from '../modules/serviceAvailability';
import { serviceCategoryMappingsReducer } from '../modules/serviceCategoryMappings/reducer';
import { servicePricingReducer } from '../modules/servicePricing';
import { error } from '../services/error/reducer';
import { pciProxy } from '../services/pciProxy';
import { checkoutReducer } from '../views/checkout';
import { confirmation } from '../views/confirmation/data/reducer';
import { datesReducer } from '../views/dates';
import { ratesReducer as ratesViewReducer } from '../views/rates';
import { summaryReducer } from '../views/summary/data/reducer';
import { views } from './views/reducer';

const data = combineReducers({
    applicableRestrictions: applicableRestrictionsReducer,
    availableCategories: availableCategoriesReducer,
    pricing: pricingReducer,
    promotedServiceCategories: promotedServiceCategoriesReducer,
    promotedServices: promotedServicesReducer,
    sellLimits: sellLimitsReducer,
    serviceAvailability: serviceAvailabilityReducer,
    servicePricing: servicePricingReducer,
    serviceCategoryMappings: serviceCategoryMappingsReducer,
});

const entities = combineReducers({
    ageCategories: ageCategoriesReducer,
    availabilityBlocks: availabilityBlocksReducer,
    bookingEngines: bookingEnginesSlice,
    categories: resourceCategoriesReducer,
    categoryImageAssignments: categoryImageAssignmentsReducer,
    chains: chainsReducer,
    enterprises: enterprisesReducer,
    exchangeRates,
    paymentCardAuthorizations,
    paymentCards,
    paymentRequests,
    payments,
    productPricing: productPricingReducer,
    products: productsReducer,
    rateGroups: rateGroupsReducer,
    rates: ratesReducer,
    reservationGroups: reservationGroupsReducer,
    reservationPrices: reservationPricesReducer,
    reservations,
    restrictions: restrictionsSlice,
    serviceDocuments: serviceDocumentsSlice,
    services: servicesReducer,
});

export const reducers = {
    app,
    configuration: configurationReducer,
    data,
    entities,
    error,
    views,
    checkout: checkoutReducer,
    cities: citiesReducer,
    confirmation,
    dates: datesReducer,
    globalization,
    hotels: hotelsReducer,
    paymentConfigurations,
    [pciProxy.moduleName]: pciProxy.reducer,
    rates: ratesViewReducer,
    resourceOrder,
    summary: summaryReducer,
};
